export default "__VITE_ASSET__CnDmBHqZ__"